const it = {
  error: {
    default: 'Errore di sistema. Riprovare più tardi',
    updSuccess: 'Aggiornamento eseguito',
    docSuccess: 'Documento generato',
    initUserDataError: 'Errore nel recupero dei dati utente o utente non trovato',
    getDataError: 'Errore nel recupero dei dati utente',
    updError: "Errore nell'aggiornamento dei dati",
    insertValue: 'Inserire un valore',
    insertValidValue: 'Inserire un valore valido',
    insertValueMinutes: 'Inserire un valore tra 0 e 59',
    insertValueHours: 'Inserire un valore tra 0 e 23',
    emailNotValid: 'Email non valida',
    passwordNotValid: 'Password non valida - deve essere almeno 8 caratteri',
    userNotAuthorized: 'Utente non autorizzato',
    errorOnDataRetrieval: 'Errore nel recupero dei dati',
    listStorage: 'Errore nel recupero della lista degli allegati',
    storage: "Errore nella gestione dell'allegato",

    notAuthorized: 'Utente non autorizzato ad eseguire questa operazione',
    insertValidPIVAValue: 'Inserire una partita IVA valida',
    insertValidCFValue: 'Inserire un codice fiscale valido',
    invalidLength: 'Lunghezza non valida',
    invalidCheckSum: 'Carattere di controllo non valido',
    inviteSuccess: 'Invito inviato con successo',
    empty: 'Il campo non deve essere vuoto',
    pageNotFoundOps: 'Ops, qualcosa è andato storto',
    pageNotFound: 'La pagina richiesta non è stata trovata',
    back2Home: 'Torna alla home',
    maintenanceOps: 'Ops, il sito è in manutenzione',
    maintenance: 'Il sito è in manutenzione, riprova più tardi',
    mutationFailed: 'Operazione di aggiornamento fallita',
    listFailed: 'Operazione di recupero informazioni fallita',
    result: 'Risultato',
    missingId: 'Non è stato possibile recuperare l\'ID richiesto',
    userNotAuthorizedDetail: 'L\'utente non ha i permessi per accedere a questa sezione',
    backToInitialPage: 'Torna alla pagina iniziale',
    materialTypeRequired: 'Seleziona un tipo di materiale',
    noColorSelected: 'Nessun colore selezionato',
    quoteDetailTypeRequired: 'Seleziona un tipo',
    productModelRequired: 'Seleziona un modello',
    sideRequired: 'Seleziona un lato di chiusura',
    dimensionTypeRequired: 'Seleziona un tipo di misure',
    handleRequired: 'Seleziona un\'altezza maniglia',
    noOptionalDetails: 'Non hai aggiunto ancora nessun elemento',
    quoteDetailTypeDoorMinHeight: 'L\'altezza minima per una portafinestra è di {minHeight} mm',
    quoteTypeRequired: 'Tipo di documento non selezionato',
    priceGroupMeasureRequired: 'Seleziona un listino misure'
  },
}
export default it
